var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPumpkin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 255,
    viewBox: "0 0 256 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_206_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.709 138.603V138.674L205.711 138.745C206.616 163.531 197.663 180.112 183.296 190.653C168.712 201.355 148.08 206.167 125.225 206.167C102.503 206.167 83.0161 200.662 68.9855 189.609C55.0917 178.664 46.135 161.957 44.9001 138.578C46.4025 101.065 80.3434 71.0393 125.225 71.0393C170.307 71.0393 205.709 101.871 205.709 138.603Z",
    fill: "#FF9B05",
    stroke: "#CB37FF",
    strokeWidth: 7.79244
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.012 118.479L125.63 123.808L123.248 118.479L128.012 118.479Z",
    fill: "#CB37FF",
    stroke: "#CB37FF",
    strokeWidth: 7.79244,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 51.1C139.246 55.18 135.066 65.4 134.007 70H122.5C122.5 63.28 130.171 51.2 134.007 46L147.5 51.1Z",
    fill: "#FF9B05",
    stroke: "#CB37FF",
    strokeWidth: 7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6492 125.282L77.4578 133.597V142.836L92.575 151.458L101.83 142.836C124.537 150.227 149.136 144.478 158.597 140.68L163.533 148.379L177.416 142.836L179.267 131.133L190.991 125.282C192.472 172.831 156.232 189.235 137.926 191.494L134.533 184.102H118.799L116.947 191.494C73.262 189.769 62.5463 146.634 62.6492 125.282Z",
    fill: "#CB37FF",
    stroke: "#CB37FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.137 104.025C89.5789 100.458 92.913 98.8962 96.0338 98.8962C99.1546 98.8962 102.489 100.458 104.931 104.025C105.75 105.222 106.334 107.142 106.564 109.756C106.788 112.308 106.643 115.158 106.32 117.898C105.999 120.62 105.515 123.125 105.109 124.956C105.104 124.976 105.099 124.997 105.095 125.017H86.9728C86.9682 124.997 86.9637 124.976 86.9591 124.956C86.5526 123.125 86.0685 120.62 85.7474 117.898C85.4243 115.158 85.28 112.308 85.5038 109.756C85.7332 107.142 86.3177 105.222 87.137 104.025Z",
    fill: "#CB37FF",
    stroke: "#CB37FF",
    strokeWidth: 7.79244
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.137 104.025C148.579 100.458 151.913 98.8962 155.034 98.8962C158.155 98.8962 161.489 100.458 163.931 104.025C164.75 105.222 165.334 107.142 165.564 109.756C165.788 112.308 165.643 115.158 165.32 117.898C164.999 120.62 164.515 123.125 164.109 124.956C164.104 124.976 164.099 124.997 164.095 125.017H145.973C145.968 124.997 145.964 124.976 145.959 124.956C145.553 123.125 145.068 120.62 144.747 117.898C144.424 115.158 144.28 112.308 144.504 109.756C144.733 107.142 145.318 105.222 146.137 104.025Z",
    fill: "#CB37FF",
    stroke: "#CB37FF",
    strokeWidth: 7.79244
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_206_39",
    x: 0.700001,
    y: 0.199512,
    width: 255.27,
    height: 254.164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_206_39"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_206_39",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpkin);
export default __webpack_public_path__ + "static/media/Pumpkin.c7255dac4af06f7d345659564e6e3db7.svg";
export { ForwardRef as ReactComponent };